export enum dataStreamTypes {
    miningOverall = "TxtMining_overall",
    miningNovelty = "TxtMining_novelty",
    diffexpr = "DiffExpr",
    otp = "OTP",
    otg = "OTG"
}

export enum Stages {
    search = "search",
    rankings = "rankings",
    evidence = "evidence",
    kg = "kg"
}

export enum nodeTypes {
    disease = "DISEASE",
    gene = "GENE_PROTEIN",
    drug = "DRUG",
    anatomy = "ANATOMY",
    phynotype = "EFFECT_PHENOTYPE",
    exposure = "EXPOSURE",
    process = "BIOLOGICAL_PROCESS",
    component = "CELLULAR_COMPONENT",
    function = "MOLECULAR_FUNCTION",
    pathway = "PATHWAY",
    moa = "MOA"
}

export enum scoreTypes {
    mscore = "mscore",
    detailedScore = "detailed_score"
}

export enum quantEvidence {
    total_comentions = "total_comentions",
    odds_ratio = "odds_ratio",
    diffexpr_up = "diffexpr_up",
    diffexpr_down = "diffexpr_down",
    bbprot_up = "bbprot_up",
    bbprot_down = "bbprot_down",
    methods_count = "methods_count"
}

export enum sankeyNodeTypes {
    gene = "gene",
    data_stream = "data_stream",
    saturation = "saturation",
    weight = "weight",
    sum = "sum",
    score = 'score'
}

export enum txtminingFields {
    mutation = 'mutation',
    relation = 'relation',
    hit = 'hit'
}

export interface MeshNode {
    id: string;
    name: string;
    children?: MeshNode[];
    mscore?: number;
    histData?: number[];
};

export interface Run {
    run_id: string;
    date: Date;
}
